<script>
    import { createEventDispatcher } from "svelte";

    export let label;
    export let value;
    export let required;
    export let readonly = false;

    if (!value) value = false;

    const dispatch = createEventDispatcher();

    const handleChange = () => {
        if (readonly) return;
        value = !value;
        dispatch("change");
    };
</script>

<style>
    label {
        height: 25px;
        width: 25px;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .checkmark.checked:after {
        display: block;
    }

    .checkmark:after {
        left: 9px;
        top: 5px;
        width: 7px;
        height: 13px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
</style>

<label
    class={readonly ? 'block relative text-md' : 'block relative text-md cursor-pointer'}
    on:click|preventDefault={handleChange}>
    <span
        class={value ? 'checkmark checked bg-blue-500 rounded' : 'checkmark bg-gray-400 rounded'} />
    <input type="checkbox" class="hidden" bind:checked={value} {required} />
    {#if label}<span class="pl-4"> {label}</span>{/if}
</label>
